import React, { Component } from 'react'
import cx from 'classnames'
import { tween, delay, chain, easing } from 'popmotion'
import styler from 'stylefire'

import './hero-unit-title.scss'

export default class HeroUnitTitle extends Component {

    state = {
        titleIndex: 0,
        titleSizes: [ 0, 0, 0 ]
    }

  constructor (props) {
      super(props)
      
      this.titleContainerRef = React.createRef()
      this.svgLineRef = React.createRef()
  }

  onScroll = () => {
    if (window.innerWidth < 670) return

    let retracted = false
    if (window.pageYOffset === 0) {
        retracted = false
    } else {
        retracted = true
    }
    this.setState({ retracted })
  }

  shuffleTitles = () => {
    const { lineStyler } = this
    let { titleIndex, titleSizes } = this.state
    const oldTitleSize = titleSizes[titleIndex]

    this.spanTitles[titleIndex].className = ''

    titleIndex += 1
    if (titleIndex === this.state.titleSizes.length) {
        titleIndex = 0
    }

    this.spanTitles[titleIndex].className = 'active'

    const newTitleSize = titleSizes[titleIndex]

    chain(
        tween({
            from: oldTitleSize.x,
            to: newTitleSize.x,
            duration: 1000,
            ease: easing.easeInOut
        }).start(v => {
            lineStyler.set('x1', v - 5)
        }),
        delay(500),
        tween({
            from: oldTitleSize.x + oldTitleSize.width,
            to: newTitleSize.x + newTitleSize.width,
            duration: 1000,
            ease: easing.easeInOut
        }).start(v => {
            lineStyler.set('x2', v - 5)
        })
    )

    this.setState({ titleIndex })
  }

  componentDidMount () {
    const { x: titleX } = this.titleContainerRef.current.getBoundingClientRect()
    this.spanTitles = [...this.titleContainerRef.current.querySelectorAll('span')]
    const titleSizes = this.spanTitles.map(span => {
        let { x, width } = span.getBoundingClientRect()
        x -= titleX
        return { x, width }
    })
    this.setState({ titleSizes })

    this.lineStyler = styler(this.svgLineRef.current)

    this.titleInterval = setInterval(this.shuffleTitles, 2500)

    window.addEventListener('scroll', this.onScroll, false)
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.onScroll, false)
    clearInterval(this.titleInterval)
  }

  render() {

    const { titleIndex, titleSizes } = this.state
    const className = cx(
        'app-title',
        { 'retracted': this.state.retracted }
    )
    return (
        <div className={className}>
            <h4>The XR Directory</h4>
            <h1>
                Find the perfect Partner for your <br />
                <div
                    ref={this.titleContainerRef} 
                    className="word-highlight">
                    <span className="active"> Virtual </span>
                    <span> Augmented </span>
                    <span> Mixed </span>
                    <svg viewbox="0 0 500 100" xmlns="http://www.w3.org/2000/svg">
                        <line 
                            x1={titleSizes[titleIndex].x} 
                            y1="0" 
                            x2={isNaN(titleSizes[titleIndex].x + titleSizes[titleIndex].width - 5) ? 0 : titleSizes[titleIndex].x + titleSizes[titleIndex].width - 5}
                            y2="0" 
                            stroke="#fff" 
                            ref={this.svgLineRef} />
                    </svg>
                </div>
                Reality Campaign
            </h1>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/hero-unit/hero-unit-title/index.jsx